import React from 'react';
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import Skeleton from "../../components/Skeleton/Skeleton";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import NavLink from 'react-router-dom/es/NavLink';

const DeclaredValue = () => {
  
  return (
    <div className="wrapper mb36">
      <Breadcrumbs/>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/learn/page-components/text-block/declared-value-heading.html"
      />
      <div className="box-wrapper">
        <div className="fg fg--box-wrapper">
          <div className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
            <NavLink to="/ship/products/nfg" className="content-container content-container--link content-container--hover-border background-white">
              <div className="two-three-rows__image-container">
                <img src="./content/ship/assets/images/NFG_Primary_453x287.svg" alt="" className="cover-image"/>
              </div>
              <div className="two-three-rows__card-text flex flex-column">
                <h2 className="two-three-rows__item-title two-three-rows__item-title--price-spaced">Next Flight Guaranteed (NFG℠)</h2>
                <p className="h2 text-bold color-primary-blue two-three-rows__bottom-aligned-text">$50,000</p>
              </div>
            </NavLink>
          </div>
          <div className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
            <NavLink to="/ship/products/southweststandard" className="content-container content-container--link content-container--hover-border background-white">
              <div className="two-three-rows__image-container">
                <img src="./content/ship/assets/images/Standard_Primary_453x287.svg" alt="" className="cover-image"/>
              </div>
              <div className="two-three-rows__card-text flex flex-column">
                <h2 className="two-three-rows__item-title two-three-rows__item-title--price-spaced">
                  <div>Southwest Standard</div>
                </h2>
                <p className="h2 text-bold color-primary-blue two-three-rows__bottom-aligned-text">$25,000</p>
              </div>
            </NavLink>
          </div>
          <div className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
            <NavLink to="/ship/products/freshfast" className="content-container content-container--link content-container--hover-border background-white">
              <div className="two-three-rows__image-container">
                <img src="./content/ship/assets/images/Fresh_Primary_453x287.svg" alt="" className="cover-image"/>
              </div>
              <div className="two-three-rows__card-text flex flex-column">
                <h2 className="two-three-rows__item-title two-three-rows__item-title--price-spaced">
                  <div>Fresh Fast</div>
                </h2>
                <p className="h2 text-bold color-primary-blue two-three-rows__bottom-aligned-text">$15,000*</p>
              </div>
            </NavLink>
          </div>
          <div className="fg__col-lg-6 fg__col-md-12 fg__col-sm-12">
            <div className="content-container background-white">
              <div className="two-three-rows__card-text two-three-rows__card-text--full-height">
                <h2 className="two-three-rows__item-title two-three-rows__item-title--price-spaced">Any fragile shipment or articles of high value shipment</h2>
                <p className="h2 text-bold color-primary-blue two-three-rows__bottom-aligned-text">$500</p>
              </div>
            </div>
          </div>
          <div className="fg__col-lg-6 fg__col-md-12 fg__col-sm-12">
            <div className="content-container background-white">
              <div className="two-three-rows__card-text two-three-rows__card-text--full-height">
                <h2 className="two-three-rows__item-title two-three-rows__item-title--price-spaced">Any perishable shipment</h2>
                <p className="h2 text-bold color-primary-blue two-three-rows__bottom-aligned-text">$15,000</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li>
            <p>*Perishables only</p>
        </li>
        <li>
          <p>Customers may declare value for any shipment, excluding With Heart shipments.</p>
        </li>
        <li>
          <p>When any shipment consists of two (2) or more pieces, the declared value for each piece shall be determined by dividing the value declared on the air waybill by the number of pieces in the shipment.</p>
          <p>International shipments are covered under the Montreal Protocol and/or Warsaw Convention with increased limits of liability. Refer to <a target="_blank" rel="noopener noreferrer"
            href="./pdf/IATAresolution600b-july2010.pdf">IATA Resolution 600b</a> for complete details.</p>
        </li>
        <li>
          <p>The declared value charges are subject to Federal Excise Tax. Refer to the Southwest <a target="_blank" rel="noopener noreferrer" href="./content/home/assets/pdfs/Approved_CargoContractofCarriage.pdf">Contract of Carriage</a> for complete details.</p>
        </li>
      </ul>
    </div>
  )
  
};

export default DeclaredValue;



// WEBPACK FOOTER //
// ./src/pages/learn/DeclaredValue.js